import { DataSource } from '@angular/cdk/table';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileRecordInterface, LoopBackConfig } from '@careapp/angular-sdk';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs/Rx';

@Component({
  selector: 'customer-files-table',
  templateUrl: './customer-files-table.component.html',
  styleUrls: ['./customer-files-table.component.scss']
})
export class CustomerFilesTableComponent implements OnInit {
  @Input()
  set files(data: FileRecordInterface[]) {
    this.dataChange.next(data);
  }

  // Access token for downloading files
  @Input() token: string;

  @Output() removeFile = new EventEmitter();

  dataChange: BehaviorSubject<FileRecordInterface[]> = new BehaviorSubject([]);
  dataSource: CustomerFilesDataSource;
  displayedColumns: Array<string>;

  ngOnInit() {
    this.displayedColumns = ['originalFileName', 'lastUpdated', 'id'];
    this.dataSource = new CustomerFilesDataSource(this.dataChange.asObservable());
  }

  fileLink(file: FileRecordInterface) {
    const path = LoopBackConfig.getPath();
    const version = LoopBackConfig.getApiVersion();
    return `${path}/${version}/files/${file.id}/download?access_token=${this.token}`;
  }
}

export class CustomerFilesDataSource extends DataSource<any> {
  constructor(public data: Observable<Array<FileRecordInterface>>) {
    super();
  }

  connect(): Observable<Array<FileRecordInterface>> {
    return this.data;
  }

  disconnect() {
    // lint
  }
}
